import React from 'react';
import styles from './how-it-works.module.css';

const HowItWorks: React.FC = () => {
  return (
    <div className={styles.pageWrapper}>
      <section className={styles.howItWorks}>
      <div className="container">
        <h2 className={styles.howItWorksTitle}>How Briqq Works</h2>
        
        <div className={styles.steps}>
          <div className={styles.step}>
            <div className={styles.stepIcon}>🔗</div>
            <h3 className={styles.stepTitle}>1. Connect Portfolio</h3>
            <p className={styles.stepDescription}>
              Securely link your brokerage accounts via Plaid or manually add your holdings. We sync your portfolio data with bank-level security—no trading access, ever.
            </p>
          </div>
          
          <div className={styles.step}>
            <div className={styles.stepIcon}>⚙️</div>
            <h3 className={styles.stepTitle}>2. Build Your Profile</h3>
            <p className={styles.stepDescription}>
              Sync your portfolio with Plaid and we'll auto-generate your investor profile, inferring risk, horizon, and sector focus from your holdings. You can edit anytime for deeper personalization.
            </p>
          </div>
          
          <div className={styles.step}>
            <div className={styles.stepIcon}>🧠</div>
            <h3 className={styles.stepTitle}>3. Get Daily Intelligence</h3>
            <p className={styles.stepDescription}>
              Get your personalized risk score and market brief every morning. Track how today's macro shifts, earnings moves, and market signals affect your holdings, down to each stock.
            </p>
          </div>
        </div>

        <div className={styles.privacySection}>
          <h3 className={styles.privacyTitle}>Privacy & Security</h3>
          <div className={styles.privacyContainer}>
            <div className={styles.privacyGrid}>
              <div>
                <div className={styles.privacyItemIcon}>🛡️</div>
                <h4 className={styles.privacyItemTitle}>Plaid-Level Security</h4>
                <p className={styles.privacyItemText}>Bank-grade encryption and security protocols</p>
              </div>
              <div>
                <div className={styles.privacyItemIcon}>🚫</div>
                <h4 className={styles.privacyItemTitle}>No Trading Access</h4>
                <p className={styles.privacyItemText}>Read-only access to your portfolio data</p>
              </div>
              <div>
                <div className={styles.privacyItemIcon}>🔒</div>
                <h4 className={styles.privacyItemTitle}>Data Encryption</h4>
                <p className={styles.privacyItemText}>All data encrypted in transit and at rest</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
  );
};

export default HowItWorks; 